import { render, staticRenderFns } from "./FornecedorDashboard.vue?vue&type=template&id=4f95d57c"
import script from "./FornecedorDashboard.vue?vue&type=script&lang=js"
export * from "./FornecedorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports